import type { TrackingProperties } from "@b2bportal/air-shopping-api";
import type {
  CipherText,
  PaymentOpaqueValue,
  ProductOpaqueValue,
  CompleteInteractiveAuthRequest,
  FulfillPendingInteractivePaymentAuth,
} from "@b2bportal/purchase-api";
import { CallState } from "@hopper-b2b/types";
import type { CartFulfillError } from "../../../types";

// TODO - types should come from FulfillSuccess
export type CartFulfillSuccessContext = {
  fulfillCipherText?: CipherText;
  fulfilledPayments?: Array<PaymentOpaqueValue>;
  fulfilledProducts?: Array<ProductOpaqueValue>;
  // Products the provider declined at fulfillment (FulfillSuccess.notPurchasedProducts):
  // kept in the order at no charge and excluded from `fulfilledProducts`, while the
  // purchase still succeeded. Empty for the vast majority of orders.
  notPurchasedProducts?: Array<ProductOpaqueValue>;
  fulfillRequestPayments?: Array<PaymentOpaqueValue>;
  userAction?: { url: string };
  trackingProperties: TrackingProperties;
};

// `actionDetails` is optional: this context is also populated from the card-api
// InteractiveAuthResponse, which does not carry it yet.
export type CartFulfillPendingInteractiveContext = {
  pendingInteractive: Omit<
    FulfillPendingInteractivePaymentAuth,
    "token" | "FulfillResponse" | "actionDetails"
  > &
    Partial<Pick<FulfillPendingInteractivePaymentAuth, "actionDetails">>;
};

export type CartFulfillCompleteInteractiveContext = {
  completeInteractive: Omit<CompleteInteractiveAuthRequest, "token">;
};

export type CartFulfillErrorContext = {
  error?: CartFulfillError;
};

export type CartFulfillContext = CartFulfillSuccessContext &
  CartFulfillErrorContext &
  CartFulfillPendingInteractiveContext &
  CartFulfillCompleteInteractiveContext & {
    callState?: CallState;
  };

export const CartFulfillInitialContext: CartFulfillContext = {
  fulfillCipherText: undefined,
  fulfilledProducts: [],
  notPurchasedProducts: [],
  fulfilledPayments: [],
  fulfillRequestPayments: [],
  userAction: undefined,
  pendingInteractive: {
    actions: [],
    paymentMetadata: undefined,
  },
  completeInteractive: {
    results: [],
  },
  error: undefined,
  callState: CallState.NotCalled,
  trackingProperties: {},
};
